module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2013.1cc2eb0b.md";